<template>
  <v-layout elevation-7>
    <v-flex>
      <v-card v-if="model != null"
      >
        <v-parallax
          src="/static/images/track17-card.jpg"
          height="150"
        >
          <v-layout
            align-center
            column
            justify-center
            class="lightbox2"
          >
            <h1 class="display-1 mb-1 s-card-title font-effect-3d-float">China</h1>
            <h4
              style="width:100%; padding-left:10px; padding-right:10px;"
              class="subheading s-card-subtitle text-xs-center">{{ model.baseInfo.lastStatus }}</h4>
          </v-layout>
        </v-parallax>

        <v-container
          id="grid"
          fluid
          grid-list-sm
          tag="section"
        >
          <v-layout wrap>
            <!--<v-flex class="subheading">상품정보</v-flex>-->
            <!--<v-flex xs12 order-xs0>-->
              <!--<v-layout column>-->
                <!--<v-flex>-->
                  <!--<v-card flat dark>-->
                    <!--<v-card-text>{{ "APPLE WATCH SERIES 3 (GPS 38MM) SPACE GRAY ALUMINIUM CASE WITH BLACK SPORT BAND" }}</v-card-text>-->
                  <!--</v-card>-->
                <!--</v-flex>-->
              <!--</v-layout>-->
            <!--</v-flex>-->
            <v-flex xs6 pl-2 pr-2>
              <label-text title="상태" :text="getStatusDescr+'('+model.baseInfo.workDays+'일 소요)'"></label-text>
              <v-divider></v-divider>
            </v-flex>
            <v-flex xs6 pl-2 pr-2>
              <label-text title="지역" :text="model.baseInfo.lastLocation"></label-text>
              <v-divider></v-divider>
            </v-flex>
<!--            <v-flex xs12 pl-2 pr-2>-->
<!--              <label-text title="상태" :text="model.baseInfo.lastStatus"></label-text>-->
<!--              <v-divider></v-divider>-->
<!--            </v-flex>-->
          </v-layout>
        </v-container>
        <v-divider></v-divider>
        <v-layout
          column
          fill-height
        >
          <v-container v-if="!hasSendResult && !hasReceiveResult" fill-height fluid>
            <v-layout column class="text-xs-center">
              <v-flex  >
                <h1 v-if="!hasSendResult && !hasReceiveResult" class="title">조회된 데이터가 없습니다</h1>
              </v-flex>
            </v-layout>
          </v-container>

          <v-flex>
            <v-flex md5 pl-3 pt-3 pb-3>
              <h3>* 배송지 정보</h3>
            </v-flex>
            <template v-for="(item, index) in this.model.receiveSteps">
              <delivery-list-item v-bind:key="index"
                                  v-bind:title="item.status == '' ? '-' : item.status"
                                  v-bind:green-chip="item.location"
                                  v-bind:date="item.dateTime"></delivery-list-item>
              <v-divider v-if="index + 1 < model.receiveSteps.length" :key="`divider-${index}`"></v-divider>
            </template>
          </v-flex>

          <v-flex>
            <v-divider></v-divider>
            <v-flex md5 pl-3 pt-3 pb-3>
              <h3>* 발송지 정보</h3>
            </v-flex>
            <template v-for="(item, index) in this.model.sendSteps">
              <delivery-list-item v-bind:key="index"
                                  v-bind:title="item.status == '' ? '-' : item.status"
                                  v-bind:green-chip="item.location"
                                  v-bind:date="item.dateTime"></delivery-list-item>
              <v-divider v-if="index + 1 < model.sendSteps.length" :key="`divider-${index}`"></v-divider>
            </template>
          </v-flex>

<!--          <v-flex>-->
<!--            <v-flex md5 pl-3 pt-3>-->
<!--              <h3>* 발송지 정보</h3>-->
<!--            </v-flex>-->
<!--            <template v-for="(item, index) in this.model.list">-->
<!--              <delivery-list-item v-bind:key="index"-->
<!--                v-bind:title="item.status == '' ? '-' : item.status"-->
<!--                v-bind:primary-chip="item.type"-->
<!--                v-bind:green-chip="item.location"-->
<!--                v-bind:date="item.dateTime" v-if="item.type==='발송지'"></delivery-list-item>-->
<!--&lt;!&ndash;              <v-divider v-if="index + 1 < model.list.length" :key="`divider-${index}`"></v-divider>&ndash;&gt;-->
<!--            </template>-->
<!--          </v-flex>-->

        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import LabelText from '../LabelText'
import DeliveryListItem from '../DeliveryListItem'
export default {
  name: 'Track17Card',
  props: ['model'],
  components: {LabelText, DeliveryListItem},
  computed: {
    getStatusDescr: function () {
      // 00: 찾을수 없음, 10: 운송중, 30: 픽업, 35: 배송 실패, 40: 배송됨, 50: 알림, 20: 만료됨
      if (this.model.baseInfo.status === 0) return '찾을수 없음'
      if (this.model.baseInfo.status === 10) return '운송중'
      if (this.model.baseInfo.status === 30) return '픽업'
      if (this.model.baseInfo.status === 35) return '배송 실패'
      if (this.model.baseInfo.status === 40) return '배송됨'
      if (this.model.baseInfo.status === 50) return '알림'
      if (this.model.baseInfo.status === 20) return '만료됨'
      return ''
    },
    hasSendResult: function () {
      return this.model.sendSteps.length > 0
    },
    hasReceiveResult: function () {
      return this.model.receiveSteps.length > 0
    }
  },
  methods: {
  }
}
</script>

<style scoped>
  .lightbox {
    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.4) 0%, transparent 80px);
  }
  .lightbox2 {
    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.4) 100%);
    padding-left: 0px!important;
  }
  .info-table {
    padding-top: 8px;
    padding-bottom: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/card/Track17Card.vue